import { Checkbox, Col, Form, Row } from "antd"
import { trackAction } from "../../hooks/lesson-context"

export function ScaleRating({
  question,
  questionIndex,
  trackQuestionSubmission,
  form,
  isFacilitate = false,
  disabled = false,
  required = false,
  inReview = false,
}) {
  const stringifiedAnswers = Form.useWatch(question.uid, form) || []
  const parsedAnswers = stringifiedAnswers.map((x) => JSON.parse(x))

  return (
    <Form.Item
      name={question.uid}
      rules={[
        {
          required,
          message: "Please select an answer",
        },
        () => ({
          async validator(_, value) {
            if (!value || value.length !== 1) {
              return Promise.reject(new Error("Please select one answer"))
            }

            await trackQuestionSubmission({
              data: value.map((x) => JSON.parse(x)),
              typeUid: question.uid,
              type: question.type,
            })

            return Promise.resolve()
          },
        }),
      ]}
    >
      <Checkbox.Group style={{ width: "100%" }}>
        <Row gutter={["16", "16"]}>
          {question.answers.map((answer) => {
            const isSelected = parsedAnswers.some((x) => x.uid === answer.uid)

            return (
              <Col key={answer.uid} style={{ marginBottom: "1rem", display: "flex" }} xs={24} lg={12}>
                <Checkbox
                  disabled={parsedAnswers.length >= 1 ? !isSelected : false}
                  id={answer.uid}
                  className={`option__choice ${
                    isFacilitate !== "true" && inReview && isSelected ? "option__choice--correct" : ""
                  }`}
                  value={JSON.stringify(answer)}
                >
                  {/* {answer?.title || answer?.translations?.["1"]?.title} */}
                  {answer?.content?.title || "No title found"}
                </Checkbox>
              </Col>
            )
          })}
        </Row>
      </Checkbox.Group>
    </Form.Item>
  )
}
